import { first, flow, last, pick, split } from 'lodash/fp';
import { parse, stringify } from 'qs';

const getPathnameFromOriginalUrl = flow(split('?'), first);

const getSearchFromOriginalUrl = flow(split('?'), last);

const getLocationFromServer = (req) => ({
  protocol: req.protocol,
  host: req.get('host'),
  pathname: getPathnameFromOriginalUrl(req.originalUrl),
  search: `?${getSearchFromOriginalUrl(req.originalUrl)}`,
  href: req.originalUrl,
});

const getLocationFromClient = () =>
  flow(
    pick(['protocol', 'host', 'pathname', 'search', 'href']),
    ({ protocol, host, pathname, search, href }) => ({
      protocol: protocol.replace(/:$/, ''),
      host,
      pathname,
      search,
      href,
    }),
  )(global.location);

export const parseSearch = (search, params = {}) =>
  parse(search, { ignoreQueryPrefix: true, ...params });

export const stringifyQuery = (query, params = {}) =>
  stringify(query, { addQueryPrefix: true, ...params });

export const paramParseSearch = (params) => (query) =>
  parseSearch(query, params);

export const paramStringifyQuery = (params) => (query) =>
  stringifyQuery(query, params);

export const toUrl = ({ pathname, search }) => {
  let url = [pathname];

  if (search && search.replace('?', '')) {
    url = [...url, search];
  }

  return url.join('');
};

export default (...args) => {
  return __SERVER__
    ? getLocationFromServer(...args)
    : getLocationFromClient(...args);
};
